import { doRequest } from '@r1-frontend/do-request';
import { EPriceTypes } from '@r1-frontend/api-domru/api-content/_dto/shop-item.types';
import { requestByConnection, RequestDto, ResponseDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { constructorAnalytics } from '~/src/features/tariffBuilder/analytics';

const SUCCESS_STATUS = [0, 6];

type TEquipData = {
    ids: number[],
    duration: number[],
    costType: number[],
}

interface ISubmitRequestProps {
    hasTv: boolean,
    fio: string,
    phone: string,
    domain: string,
    salePackageId: number,
    routers: TEquipData,
    decoders: TEquipData,
    street?: string,
    house?: string,
    flat?: string,
    csrf: string,
}

/**
 * Отправка заявки на подключение
 */
export const submitRequest = async({
    hasTv,
    fio,
    phone,
    salePackageId,
    decoders,
    routers,
    street,
    house,
    flat,
    csrf,
}: ISubmitRequestProps) => {

    const leasing_duration = routers.duration.find(duration => duration > 0);
    const cost_type = leasing_duration ? EPriceTypes.Leasing : EPriceTypes.Possess;

    const tv_equipment_duration = decoders.duration.find(duration => duration > 0);
    const tv_equipment_buy = tv_equipment_duration ? EPriceTypes.Leasing : EPriceTypes.Possess;

    const data: RequestDto = {
        check_call_type: window.location.pathname,
        fio,
        phone,
        csrf,
        plan: salePackageId,
        product_id: hasTv ? [EProductsId.internet, EProductsId.tv] : [EProductsId.internet],
        router: routers.ids,
        leasing_duration,
        cost_type,
        tv_equipment_id: decoders.ids,
        tv_equipment_duration,
        tv_equipment_buy,
        street,
        house_num: Number(house) || undefined,
        office: Number(flat) || undefined,
    };

    const response = await doRequest.apiRequest<ResponseDto>(
        requestByConnection(data),
    );

    if (response.isSuccess) {
        if (SUCCESS_STATUS.includes(response.payload.status)) {
            constructorAnalytics.submitRequest.requestConnectionSuccess();
        } else {
            constructorAnalytics.submitRequest.requestConnectionError(response.payload.message, response.payload.status);
        }
    } else {
        constructorAnalytics.submitRequest.requestConnectionError(response.error.message);
    }
};
